import { CaseDraftParameter, CaseDraftPayload } from "app/components/ai-chat-assistant/types";


const toRawValue = (field: { values?: Array<{ v?: string | number }> }) => {
  const values = (field?.values ?? [])
    .map((x) => x?.v)
    .filter((v): v is string | number => v !== undefined && v !== null);
  if (values.length > 1) {
    return values;
  }

  return values[0];
};

export const toDraftQuery = (draft: CaseDraftPayload): CaseDraftParameter[] => {
  if (!draft?.fields) {
    return [];
  }
  return Object.entries(draft.fields).flatMap(([dataTag, field]) => {
    const rawValue = toRawValue(field);
    if (rawValue === undefined) {
      return [];
    }
    return [{ DataTag: dataTag, Value: rawValue }];
  });
};
